// @flow
import * as React from 'react';
import Group from 'sail/Group';
import {Body} from 'sail/Text';

type ChartIconGroupProps = {|
  description: string,
  label?: string,
  children: React.Node,
|};

export const ChartIconGroup = ({
  description,
  label,
  children,
}: ChartIconGroupProps) => {
  const labelComponent = label ? <Body color="gray">{label}:</Body> : null;
  return (
    <Group direction="horizontal" alignItems="center" spacing={8}>
      {labelComponent}
      <Group role="img" aria-label={description} direction="horizontal">
        {children}
      </Group>
    </Group>
  );
};
